export const KINDS = {
    INDENTED: "Indented",
    FULL: "Full",
} as const;

export type KINDS = typeof KINDS[keyof typeof KINDS];
